import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { TACHYON_IMAGE, CONTACT_INFO } from "../mock";
import { useReveal } from "../hooks/useReveal";
import { Sparkles, Clock, Tag, ArrowRight } from "lucide-react";

const Tachyon = () => {
  const { t } = useLanguage();
  const r = useReveal();

  return (
    <section
      id="tachyon"
      className="relative py-16 sm:py-24 md:py-32 overflow-hidden bg-gradient-to-br from-brand-plumDark via-[#3d3253] to-brand-plum"
    >
      <div className="absolute top-10 right-10 w-96 h-96 rounded-full bg-brand-lavender/20 blur-3xl" />
      <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-brand-gold/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 sm:gap-16 items-center">
        <div className="relative">
          <div className="absolute -inset-3 rounded-[2.2rem] bg-brand-gold/20 blur-md" />
          <div className="relative rounded-[2rem] overflow-hidden shadow-[0_40px_90px_rgba(0,0,0,0.4)] border border-white/10">
            <img
              src={TACHYON_IMAGE}
              alt="Camera Tachionica"
              className="w-full h-[420px] sm:h-[520px] lg:h-[600px] object-cover"
            />
          </div>
          <span className="absolute top-5 left-5 bg-brand-gold text-brand-plumDark text-xs tracking-[0.2em] uppercase px-4 py-2 rounded-full font-medium shadow-lg">
            {t.tachyon.kicker}
          </span>
        </div>

        <div ref={r.ref} className={r.className}>
          <div className="flex items-center gap-2 text-brand-goldLight mb-5">
            <Sparkles size={18} />
            <p className="text-xs tracking-[0.4em] uppercase">Exclusive</p>
          </div>
          <h2 className="font-serif text-3xl sm:text-5xl md:text-6xl text-brand-cream mb-5 leading-tight">
            {t.tachyon.title}
          </h2>
          <p className="text-brand-lavender text-base sm:text-lg mb-7 leading-relaxed">
            {t.tachyon.subtitle}
          </p>
          <p className="text-brand-cream/75 leading-relaxed mb-4">{t.tachyon.p1}</p>
          <p className="text-brand-cream/75 leading-relaxed mb-8">{t.tachyon.p2}</p>

          <p className="text-brand-goldLight font-medium mb-4">{t.tachyon.benefitsTitle}</p>
          <ul className="grid sm:grid-cols-2 gap-3 mb-9">
            {t.tachyon.benefits.map((b, i) => (
              <li key={i} className="flex items-start gap-3 text-brand-cream/85">
                <span className="mt-1.5 w-2 h-2 rounded-full bg-brand-gold flex-shrink-0" />
                <span className="text-sm leading-snug">{b}</span>
              </li>
            ))}
          </ul>

          {/* Price card */}
          <div className="flex flex-wrap items-center gap-5 bg-white/8 backdrop-blur border border-white/15 rounded-2xl p-5 sm:p-6 mb-6">
            <div className="flex items-center gap-3 pr-5 border-r border-white/15">
              <Tag size={20} className="text-brand-goldLight" />
              <div>
                <p className="text-xs text-brand-lavender uppercase tracking-wider">{t.tachyon.priceLabel}</p>
                <p className="font-serif text-3xl text-brand-cream">{t.tachyon.price}</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Clock size={20} className="text-brand-goldLight" />
              <div>
                <p className="text-xs text-brand-lavender uppercase tracking-wider">Durata</p>
                <p className="font-serif text-2xl text-brand-cream">{t.tachyon.duration}</p>
              </div>
            </div>
          </div>
          <p className="text-xs text-brand-cream/50 mb-8">{t.tachyon.note}</p>

          <a
            href={CONTACT_INFO.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex w-full sm:w-auto items-center justify-center gap-2 bg-brand-gold hover:bg-brand-goldLight text-brand-plumDark font-medium px-8 py-4 rounded-full transition-all duration-300 hover:shadow-xl hover:-translate-y-0.5"
          >
            {t.tachyon.cta}
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Tachyon;
